import app from 'flarum/forum/app';
import on from './gate';
import Component from 'flarum/common/Component';
export default class SongPicker extends Component {
  query = '';
  results = [];
  error = '';
  sequence = 0;
  loading = false;
  onremove() {
    clearTimeout(this.timer);
    this.sequence++;
  }
  search(value) {
    this.query = value;
    this.error = '';
    clearTimeout(this.timer);
    const seq = ++this.sequence;
    if (value.trim().length < 2) {
      this.results = [];
      this.loading = false;
      return;
    }
    this.loading = true;
    this.timer = setTimeout(() => app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/challenges/song-search',
      params: {
        q: value.trim()
      },
      errorHandler: () => {}
    }).then(r => {
      if (seq === this.sequence) this.results = r.data;
    }).catch(e => {
      if (seq === this.sequence) {
        this.results = [];
        this.error = e.status === 503 ? "Song search isn't set up yet" : e.status === 429 ? 'Too many searches. Try again in a minute.' : 'Song search failed. Try again.';
      }
    }).finally(() => {
      if (seq === this.sequence) this.loading = false;
      m.redraw();
    }), 350);
  }
  view() {
    if (!on()) return null;
    const {
      state,
      composer
    } = this.attrs;
    return m("section", {
      className: "Challenge-picker"
    }, m("h3", null, "Pick your song"), m("input", {
      className: "FormControl",
      type: "search",
      "aria-label": "Search songs",
      placeholder: "Search track or artist",
      value: this.query,
      oninput: e => this.search(e.target.value)
    }), this.loading && m("p", null, "Searching\u2026"), this.error && m("p", {
      role: "alert"
    }, this.error), m("ul", {
      className: "Challenge-results"
    }, this.results.map(song => m("li", {
      key: song.spotify_track_id
    }, m("button", {
      type: "button",
      onclick: () => {
        state.song = song;
        this.results = [];
        if (!composer.title().trim()) composer.title(('30 days: ' + song.track + ' (' + song.artist + ')').slice(0, 80));
      }
    }, song.image_url && m("img", {
      src: song.image_url,
      alt: ""
    }), m("span", null, m("strong", null, song.track), m("br", null), song.artist, m("br", null), m("small", null, song.album, " \xB7 ", song.year)))))), state.song && m("p", {
      className: "Challenge-selected"
    }, m("strong", null, state.song.track), " \u2014 ", state.song.artist, m("br", null), m("small", null, state.song.album, " \xB7 ", state.song.year)), m("div", {
      className: "Challenge-parts"
    }, ['rhythm', 'solo', 'vocals'].map(part => m("label", null, m("input", {
      type: "checkbox",
      checked: state.parts.includes(part),
      onchange: e => {
        state.parts = e.target.checked ? [...state.parts, part] : state.parts.filter(p => p !== part);
        if (!state.parts.includes(state.hard_part)) state.hard_part = null;
      }
    }), " ", part === 'vocals' ? 'Vocals (sing while playing)' : part[0].toUpperCase() + part.slice(1)))), m("label", null, "Hardest part ", m("select", {
      className: "FormControl",
      value: state.hard_part || 'none',
      onchange: e => state.hard_part = e.target.value === 'none' ? null : e.target.value
    }, m("option", {
      value: "none"
    }, "None"), state.parts.map(p => m("option", {
      value: p
    }, p[0].toUpperCase() + p.slice(1))))));
  }
}